export default "__VITE_ASSET__DFTNpK1k__"